import { z } from "zod"

export const ProjectRoleSchema = z.enum(["project_admin", "member"]).catch("member")
export type TProjectRole = z.infer<typeof ProjectRoleSchema>
